import jwt from 'jsonwebtoken';
import store from '@/store';
import {
  AUTH_LOGOUT,
  BLOCK_REDIRECTS_TO_LOGIN_PAGE,
  RETURN_TO_ASKED_URL,
  UNBLOCK_REDIRECTS_TO_LOGIN_PAGE
} from '@/store/auth/authAction';
import router from '@/router';

export function getExternalToolReference(token: string): string {
  if (jwt === null) {
    throw new Error('Error in jwt package');
  } else {
    const decodedJWT = jwt.decode(token, {json: true, complete: true}) as any;
    const url = decodedJWT.payload?.aud;
    if (!url) {
      throw new Error('Token not valid');
    }
    return url as string;
  }
}


export async function disconnectAndRefresh() {
  await store.dispatch(BLOCK_REDIRECTS_TO_LOGIN_PAGE);
  try {
    await store.dispatch(AUTH_LOGOUT);
  } finally {
    await store.dispatch(UNBLOCK_REDIRECTS_TO_LOGIN_PAGE);
  }
  window.location.reload();
}


